

<template>
  <!-- Hero Area Start -->
  <section class="hero_area">
    <img class="shape_5" src="../assets/img/shape_6.png" alt="img" />
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="hero_text">
            <h1 class="hero_title">Calidad y sabor <span>en cada orden</span></h1>
            <a
              href="https://wa.me/5216647980740?text=Hola,%20quiero%20hacer%20un%20pedido"
              class="cta_btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-whatsapp"></i> Contactar
            </a>
          </div>
        </div>
        <div class="col-md-6">
          <div class="hero_img">
            <div class="hero_shape">
              <img
                v-for="(item, key) in hero_shape"
                v-bind:class="item.cssClass"
                v-bind:src="item.img"
                v-bind:alt="item.altText"
                :key="key"
              />
            </div>
            <img v-bind:src="heroImage" alt="hero img" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Hero Area End -->
</template>

<script>
import { TimelineMax } from "gsap";

export default {
  name: "HeroArea",
  data() {
    return {
      heroImage: require("../assets/img/hero_pizza.png"),
      hero_shape: [
       // {
       //   img: require("../assets/img/hero_shape_1.png"),
       //   cssClass: "shape_1",
       //   altText: "img",
      // },
        {
          img: require("../assets/img/hero_shape_2.png"),
          cssClass: "shape_2",
          altText: "img",
        },
        {
          img: require("../assets/img/hero_shape_3.png"),
          cssClass: "shape_3",
          altText: "img",
        },
        {
          img: require("../assets/img/hero_shape_4.png"),
          cssClass: "shape_4",
          altText: "img",
        },
        {
          img: require("../assets/img/scroll_pizza_1.png"),
          cssClass: "scroll_pizza_1",
          altText: "img",
        },
        {
          img: require("../assets/img/scroll_pizza_2.png"),
          cssClass: "scroll_pizza_2",
          altText: "img",
        },
      ],
    };
  },
  mounted() {
    this.setScene();
  },
  methods: {
    setScene() {
      let self = this;

      // Declare Scene
      const scene = this.$scrollmagic
        .scene(self.sceneElem(".hero_area", "300", "200"))
        // Declaration of animation and attaching to element
        .setTween(
          self.getTimeLine(".scroll_pizza_1", 1, {
            x: "-200",
            y: "-50",
            ease: "Linear.easeNone",
          })
        );

      const scene2 = this.$scrollmagic
        .scene(self.sceneElem(".hero_area", "300", "250"))
        // Declaration of animation and attaching to element
        .setTween(
          self.getTimeLine(".scroll_pizza_2", 1, {
            x: "-230",
            y: "120",
            ease: "Linear.easeNone",
          })
        );

      // Add Scene to controller
      this.$scrollmagic.addScene([scene, scene2]);
    },
    sceneElem(triggerElem, duration, offset) {
      return {
        triggerElement: triggerElem,
        duration: duration,
        offset: offset,
      };
    },
    getTimeLine(triggerElem, duration, edgeObj) {
      return new TimelineMax().from(triggerElem, duration, edgeObj);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HeroArea.vue